import Icon from '../FieldTypes/Icon/Icon';
import Text from '../FieldTypes/Text/Text';

export default {
    Icon,
    Text,
};
